class MainProductSelector extends ProductSelector {
  /**
   * properties.
   */
  selectors = {
    mainProduct: '[data-main-product]',
    productMedia: '[data-product-media]',
    metaOption: '[data-meta-option]',
  };

  /**
   * constructor.
   */
  constructor() {
    super();
  }

  /**
   * connectedCallback.
   */
  connectedCallback() {
    this.mainProduct = this.closest(this.selectors.mainProduct);
    this.productMedia = this.mainProduct.querySelector(
      this.selectors.productMedia,
    );
    this.metaOptions = this.querySelectorAll(this.selectors.metaOption);
    super.updateOptions();
    super.filterOptions();

    this.metaOptions.forEach((option) =>
      option.addEventListener('change', this.handleMetaOptionChange.bind(this)),
    );
  }

  handleMetaOptionChange(e) {
    const { name, value } = e.currentTarget;
    const hiddenInput = this.querySelector(`input[type="hidden"]#${name}`);
    hiddenInput.value = value;
  }

  /**
   * onVariantChange.
   * @param {Event} event
   */
  onVariantChange(event) {
    if (event.target.hasAttribute('data-meta-option')) return;
    if (event.target.type === 'number') return;
    super.updateOptions();
    this.updateVariant();
    this.updateProductMedia();
    super.toggleAddButton(false, '');
    super.handleErrorMessage();
    super.filterOptions();

    if (!this.currentVariant) {
      super.toggleAddButton(true, '');
      super.setUnavailable();

      return;
    }

    if (!this.currentVariant.available) {
      ``;
      super.toggleAddButton(true, window.variantStrings.soldOut);
    }

    this.updateMedia();
    this.updateURL();
    super.updateVariantInput();
    this.renderProductInfo();
  }

  /**
   * updateMedia.
   */
  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;

    const productMedia = document.querySelector('product-media');
    productMedia.setActiveMedia(this.currentVariant.featured_media.id);
  }

  /**
   * updateVariant.
   */
  updateVariant() {
    this.currentVariant = this.variants.find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index].value === option;
        })
        .includes(false);
    });

    if (!this.currentVariant) {
      this.productMedia.toggleSlidesByColor(this.getColor());
    }

    this.currentVariantPrice = this.prices.find((priceObj) => {
      return priceObj.id == this.currentVariant?.id;
    });
  }

  /**
   * updateProductMedia.
   */
  updateProductMedia() {
    if (!this.productMedia || !this.currentVariant) return;

    this.productMedia.toggleSlidesByColor(this.getColor());
    this.productMedia.slideToVariantMedia(
      this.currentVariant.featured_media?.id,
    );
  }

  /**
   * getColor.
   */
  getColor() {
    this.optionsMap = {};

    this.options.forEach((option) => {
      this.optionsMap[option.name === 'colour' ? 'color' : option.name] =
        option.value;
    });

    return this.optionsMap.color;
  }

  /**
   * updateURL.
   */
  updateURL() {
    if (!this.currentVariant) return;
    const params = new URLSearchParams(window.location.search);
    params[params.has('variant') ? 'set' : 'append'](
      'variant',
      this.currentVariant.id,
    );
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?${params.toString()}`,
    );
  }

  /**
   * renderProductInfo.
   */
  renderProductInfo() {
    const destinationPrice = document.querySelector(
      `#price-${this.dataset.sectionId}`,
    );

    if (destinationPrice && this.currentVariantPrice?.price_html) {
      destinationPrice.classList.remove('visually-hidden');
      destinationPrice.innerHTML = this.currentVariantPrice.price_html;
    }
  }
}

customElements.define('main-product-selector', MainProductSelector);
